var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex flex-col" }, [
        _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
          _c("div", { staticClass: "px-4 mb-6" }, [
            _c("img", {
              staticClass:
                "shadow rounded max-w-full h-auto align-middle border-none",
              staticStyle: { width: "150px" },
              attrs: {
                alt: "...",
                src: !!_vm.avatar ? _vm.avatar : _vm.imgPlaceholder
              }
            })
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm.isFileLarge || _vm.isErrorImage
            ? _c(
                "div",
                { staticClass: "flex flex-col mb-2" },
                [
                  _vm.isFileLarge
                    ? _c("text-error", {
                        attrs: { text: "Please select correct file" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isErrorImage
                    ? _c("text-error", {
                        attrs: { text: "Please select image cover" }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex" },
            [
              !_vm.avatar
                ? _c("Button", {
                    attrs: { label: "Browse File" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "any",
                          fn: function() {
                            return [
                              _c("input", {
                                staticStyle: {
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                  left: "0",
                                  top: "0",
                                  opacity: "0",
                                  cursor: "pointer",
                                  "z-index": "2"
                                },
                                attrs: {
                                  type: "file",
                                  name: "profile_picture"
                                },
                                on: { change: _vm.onFileChange }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2462335240
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.avatar
                ? _c("Button", {
                    attrs: { label: "Cancel", variant: "default" },
                    on: { clicked: _vm.changeImage }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Full Name" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("Input", {
                  attrs: {
                    placeholder: "Full Name",
                    error:
                      _vm.$v.fullname.$dirty &&
                      (!_vm.$v.fullname.required || !_vm.$v.fullname.maxLength)
                  },
                  model: {
                    value: _vm.fullname,
                    callback: function($$v) {
                      _vm.fullname = $$v
                    },
                    expression: "fullname"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.fullname.$dirty && !_vm.$v.fullname.required
                      ? _c("text-error", {
                          attrs: { text: "Please fill your name." }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.fullname.$dirty && !_vm.$v.fullname.maxLength
                      ? _c("text-error", {
                          attrs: {
                            text:
                              "Maximum character for name is 100 characters."
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Email" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("Input", {
                  attrs: {
                    placeholder: "Email",
                    error: _vm.$v.email.$dirty && _vm.isErrorEmail
                  },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.email.$dirty && !_vm.$v.email.required
                      ? _c("text-error", {
                          attrs: { text: "Please fill your email." }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.email.$dirty && !_vm.$v.email.maxLength
                      ? _c("text-error", {
                          attrs: {
                            text:
                              "Maximum character for email is 100 characters."
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.email.$dirty && !_vm.$v.email.email
                      ? _c("text-error", {
                          attrs: { text: "Please fill your correct email." }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.emailErrorMessage.length > 0
                      ? _c("text-error", {
                          attrs: { text: _vm.emailErrorMessage }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Birthdate" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("Input", {
                  attrs: { type: "date", placeholder: "Birthdate" },
                  model: {
                    value: _vm.dob,
                    callback: function($$v) {
                      _vm.dob = $$v
                    },
                    expression: "dob"
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Bio" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "relative" },
                  [
                    _c("TextArea", {
                      attrs: {
                        placeholder: "Tell us about you",
                        error: _vm.$v.bio.$dirty && !_vm.$v.bio.maxLength,
                        maxlength: _vm.bioMaxLength,
                        rows: "10"
                      },
                      model: {
                        value: _vm.bio,
                        callback: function($$v) {
                          _vm.bio = $$v
                        },
                        expression: "bio"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "absolute right-0 text-xs",
                        staticStyle: { bottom: "15px", right: "15px" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.bio.length) +
                            "/" +
                            _vm._s(_vm.bioMaxLength)
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.bio.$dirty && !_vm.$v.bio.maxLength
                      ? _c("text-error", {
                          attrs: {
                            text:
                              "Maximum character for bio is 2000 characters."
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Language" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "el-select",
                  {
                    staticClass: "w-full",
                    attrs: { filterable: "", placeholder: "Select Language" },
                    model: {
                      value: _vm.language,
                      callback: function($$v) {
                        _vm.language = $$v
                      },
                      expression: "language"
                    }
                  },
                  _vm._l(_vm.dataLanguages, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col pt-2" },
                  [
                    _vm.$v.language.$dirty && !_vm.$v.language.required
                      ? _c("text-error", {
                          attrs: { text: "Please choose language." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Password" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "relative" },
                  [
                    _c("Input", {
                      attrs: {
                        type: _vm.showPassword ? "text" : "password",
                        placeholder: "Password"
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "absolute top-0 right-0 mr-2 mt-3 ",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.showPassword = !_vm.showPassword
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa",
                          class: _vm.showPassword ? "fa-eye-slash" : "fa-eye"
                        })
                      ]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("form-item", {
        attrs: { label: "Upload File Agreement" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "flex-1" }, [
                  !_vm.fileAgreement
                    ? _c("input", {
                        staticClass:
                          "block border border-grey-light w-full p-3 rounded",
                        attrs: {
                          type: "file",
                          name: "file_agreement",
                          accept: "application/pdf"
                        },
                        on: { change: _vm.onFileChangeAgreement }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileAgreement
                    ? _c("div", { staticClass: "flex" }, [
                        _c(
                          "span",
                          { staticClass: "mr-2 text-gray-700 font-medium" },
                          [_vm._v(_vm._s(_vm.fileAgreementName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "cursor-pointer",
                            on: { click: _vm.changeFileAgreement }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "times-circle"] }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col mb-2" }, [
      _c("p", { staticClass: "text-xs text-gray-700" }, [
        _vm._v("Minimum 900x900, Maximum 1MB")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67d67f5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d67f5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistContent/Step1.vue
// module id = null
// module chunks = 